const Whats = ({ type }) => {
  const regular = (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_362_5900)">
        <path
          d="M11.989 2.98538C10.2504 2.98666 8.54259 3.44502 7.03695 4.31451C5.53132 5.18399 4.28073 6.43404 3.4106 7.9393C2.54047 9.44456 2.08136 11.1521 2.07933 12.8908C2.0773 14.6295 2.53241 16.3381 3.39902 17.8454L1.99902 22.9854L7.24902 21.6054C8.57513 22.3264 10.0484 22.7351 11.5564 22.8002C13.0645 22.8652 14.5675 22.585 15.9508 21.9809C17.3341 21.3768 18.5611 20.4648 19.5383 19.3143C20.5156 18.1639 21.2171 16.8054 21.5895 15.3426C21.9619 13.8798 21.9952 12.3513 21.687 10.8737C21.3789 9.39599 20.7373 8.00824 19.8112 6.81624C18.8851 5.62425 17.699 4.6595 16.3434 3.9956C14.9878 3.3317 13.4985 2.98617 11.989 2.98538ZM11.999 4.65538C14.1844 4.65671 16.2798 5.52612 17.8241 7.07236C19.3685 8.6186 20.2353 10.715 20.234 12.9004C20.2327 15.0858 19.3633 17.1811 17.817 18.7255C16.2708 20.2698 14.1744 21.1367 11.989 21.1354C10.5137 21.1408 9.0649 20.7431 7.79902 19.9854L7.49902 19.8154L4.37902 20.6354L5.20902 17.5954L5.00902 17.2754C4.22636 16.0276 3.79242 14.5929 3.75236 13.1205C3.71231 11.6481 4.0676 10.1919 4.78127 8.90341C5.49494 7.61493 6.54089 6.54127 7.81028 5.79416C9.07967 5.04706 10.5261 4.65383 11.999 4.65538ZM8.47902 8.31538C8.35362 8.31894 8.23029 8.3483 8.11673 8.40163C8.00318 8.45497 7.90183 8.53114 7.81902 8.62538C7.54088 8.89313 7.32027 9.2148 7.17068 9.57072C7.02109 9.92663 6.94567 10.3093 6.94902 10.6954C7.03456 11.6259 7.3812 12.5133 7.94902 13.2554C9.02051 14.8443 10.4845 16.1291 12.199 16.9854C12.6561 17.1946 13.1273 17.3717 13.609 17.5154C14.1144 17.6685 14.6483 17.7027 15.169 17.6154C15.5139 17.5451 15.8405 17.4039 16.128 17.2008C16.4154 16.9977 16.6576 16.737 16.839 16.4354C17.0026 16.065 17.0547 15.6549 16.989 15.2554C16.919 15.1554 16.759 15.0954 16.509 14.9854C16.259 14.8454 15.039 14.2454 14.819 14.1654C14.599 14.0854 14.449 14.0454 14.259 14.2854C14.099 14.5354 13.619 15.0954 13.479 15.2554C13.339 15.4154 13.189 15.4454 12.949 15.3254C12.2158 15.0351 11.5389 14.6188 10.949 14.0954C10.4075 13.5925 9.94255 13.013 9.56902 12.3754C9.52153 12.2934 9.50648 12.1966 9.52684 12.104C9.5472 12.0114 9.6015 11.9299 9.67902 11.8754C9.81492 11.7398 9.93872 11.5925 10.049 11.4354C10.1545 11.3135 10.2389 11.1749 10.299 11.0254C10.3311 10.9575 10.346 10.8829 10.3426 10.8079C10.3391 10.7329 10.3173 10.66 10.279 10.5954C10.219 10.4854 9.71902 9.24538 9.50902 8.75538C9.29902 8.26538 9.10902 8.33538 8.94902 8.32538C8.80902 8.32538 8.64902 8.31538 8.47902 8.31538Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_362_5900">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.985382)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Whats;
